import {
  get_unread_notification_counts,
  mark_resource_notifications_read,
} from "@/apis/notifications"

export default {
  namespaced: true,
  state: {
    counts: {
      proposals: 0,
      activeProjects: 0,
      invoices: 0,
    },
    items: {
      proposals: [],
      activeProjects: [],
      invoices: [],
    },
  },
  mutations: {
    setCounts(state, counts = {}) {
      state.counts = {
        proposals: Number(counts.proposals) || 0,
        activeProjects: Number(counts.activeProjects) || 0,
        invoices: Number(counts.invoices) || 0,
      }
      state.items = {
        proposals: (counts.items && counts.items.proposals) || [],
        activeProjects: (counts.items && counts.items.activeProjects) || [],
        invoices: (counts.items && counts.items.invoices) || [],
      }
    },
  },
  getters: {
    isUnreadResource: state => (destination, resourceId) => {
      if (!resourceId || !state.items[destination]) return false
      return state.items[destination].some(id => String(id) === String(resourceId))
    },
  },
  actions: {
    async refresh({ commit }) {
      const response = await get_unread_notification_counts()
      commit("setCounts", response.data)
      return response.data
    },
    async markResourceRead({ dispatch }, payload) {
      await mark_resource_notifications_read({
        destination: payload.destination,
        resourceId: String(payload.resourceId),
      })
      return dispatch("refresh")
    },
  },
}
